import React, { useMemo } from 'react'
import type { EChartsOption } from 'echarts'
import EChartsCanvas from '../core/EChartsCanvas'
import { useAnalyticsTheme } from '../theme/useAnalyticsTheme'
import { buildAreaGradient } from '../theme/echartsTheme'

export type AnalyticsSparklineProps = {
 data: number[]
 height?: number
 color?: string
 className?: string
}

const AnalyticsSparkline: React.FC<AnalyticsSparklineProps> = ({
 data,
 height = 36,
 color,
 className,
}) => {
 const { mode, colors } = useAnalyticsTheme()
 const lineColor = color ?? colors.primary
 const empty = data.length === 0

 const option = useMemo<EChartsOption>(
  () => ({
   backgroundColor: 'transparent',
   grid: { left: 0, right: 0, top: 2, bottom: 2 },
   xAxis: { type: 'category', show: false, data: data.map((_, i) => i) },
   yAxis: { type: 'value', show: false, min: 'dataMin' },
   tooltip: { show: false },
   series: [
    {
     type: 'line',
     smooth: true,
     symbol: 'none',
     lineStyle: { width: 1.5, color: lineColor },
     areaStyle: { color: buildAreaGradient(mode, lineColor) },
     data,
    },
   ],
  }),
  [data, lineColor, mode],
 )

 return (
  <EChartsCanvas
   option={option}
   height={height}
   className={className}
   empty={empty}
   themeKey={`spark-${mode}`}
  />
 )
}

export default AnalyticsSparkline
